import { render } from "./smile.vue?vue&type=template&id=c476d474"
const script = {}
script.render = render

export default script